import React from "react";
import { PhoneLayout } from "@/features/previews/layouts";
import { Link } from "@/components/Link";
import { checkValidURL } from "@/utils/formHelper";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewPrimaryAction } from "@/features/previews/shared/components/PreviewPrimaryAction";

import { useImagesData } from "./hooks/useImagesData";
import { ImagesHeader, GalleryContainer } from "./components";

import "./ImagesTemplate.scss";

export const ImagesTemplate = (props: QRProps<"image">) => {
  const { data, isInitPreview } = useImagesData(props);

  if (!data) return null;

  const {
    albumTitle,
    albumDescription,
    albumWebsite,
    buttonText,
    buttonUrl,
    imageUrls,
    themeColor,
  } = data;

  return (
    <PhoneLayout
      page="image"
      dataQA="preview-image-container"
      backgroundColor={themeColor?.backgroundColor}
      hasIncludeBrowser
      isInitPreview={isInitPreview}
    >
      <div className="images-preview">
        <ImagesHeader
          albumTitle={albumTitle}
          albumDescription={albumDescription}
        />

        {imageUrls && imageUrls.length > 0 && (
          <div style={{ position: "relative" }}>
            <div
              className="images-preview__background-divider-top"
              style={{ backgroundColor: themeColor?.buttonColor }}
            />
            <div className="images-preview__background-divider-bottom" />
            <div
              className={`images-preview__carousel-background ${isInitPreview ? "images-preview__carousel-background--init" : ""}`}
            >
              <GalleryContainer
                images={imageUrls}
                isInitPreview={isInitPreview}
                expandable={!isInitPreview && !props?.preview}
              />

              {buttonText && imageUrls.length > 0 && (
                <div className="images-preview__button">
                  <PreviewPrimaryAction
                    text={buttonText}
                    url={buttonUrl}
                    buttonColor={themeColor?.buttonColor}
                    medium
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <div className="qr-content">
          {albumWebsite && (
            <div className="images-preview__album-website">
              <Link
                externalLink
                className="Preview-layout__link"
                href={checkValidURL(albumWebsite) || ""}
                style={{ color: themeColor?.buttonColor }}
                prefetch={false}
              >
                {albumWebsite}
              </Link>
            </div>
          )}
        </div>
      </div>
    </PhoneLayout>
  );
};
